import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PeriodJumpPicker, MONTHS, YEARS } from "@/components/PeriodJumpPicker";

export { MONTHS, YEARS };

const pad = (n) => String(n).padStart(2, "0");
const toISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// Returns { start, end, label } for the period containing anchor (Date).
export const periodRange = (period, anchor) => {
  const y = anchor.getFullYear();
  const m = anchor.getMonth();
  if (period === "month") {
    return { start: toISO(new Date(y, m, 1)), end: toISO(new Date(y, m + 1, 0)), label: `${MONTHS[m]} ${y}` };
  }
  if (period === "quarter") {
    const q = Math.floor(m / 3);
    return { start: toISO(new Date(y, q * 3, 1)), end: toISO(new Date(y, q * 3 + 3, 0)), label: `Q${q + 1} ${y}` };
  }
  return { start: `${y}-01-01`, end: `${y}-12-31`, label: String(y) };
};

const shift = (period, anchor, delta) => {
  const step = period === "month" ? 1 : period === "quarter" ? 3 : 12;
  return new Date(anchor.getFullYear(), anchor.getMonth() + delta * step, 1);
};

export const SalesPeriodBar = ({ period, setPeriod, anchor, setAnchor }) => (
  <div className="flex flex-wrap items-center gap-3" data-testid="sales-period-bar">
    <Tabs value={period} onValueChange={setPeriod}>
      <TabsList>
        <TabsTrigger value="month" data-testid="sales-period-month">Month</TabsTrigger>
        <TabsTrigger value="quarter" data-testid="sales-period-quarter">Quarter</TabsTrigger>
        <TabsTrigger value="year" data-testid="sales-period-year">Year</TabsTrigger>
      </TabsList>
    </Tabs>
    <div className="flex items-center gap-1 bg-md3-surface-container rounded-md3-md p-1">
      <Button variant="ghost" size="sm" onClick={() => setAnchor(shift(period, anchor, -1))} data-testid="sales-period-prev">
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <PeriodJumpPicker period={period} anchor={anchor} label={periodRange(period, anchor).label} onPick={setAnchor} />
      <Button variant="ghost" size="sm" onClick={() => setAnchor(shift(period, anchor, 1))} data-testid="sales-period-next">
        <ChevronRight className="h-4 w-4" />
      </Button>
      <Button variant="outline" size="sm" className="ml-1" onClick={() => setAnchor(new Date())} data-testid="sales-period-today">
        Today
      </Button>
    </div>
  </div>
);
